import { useContext, useState } from "react";
import { toast } from "react-toastify";
import { GlobalContext } from "../../../Context/GlobalContext";

const useCustomerDetails = () => {
  const { api } = useContext(GlobalContext);

  const [customerDetailsLoading, setCustomerDetailsLoading] = useState(false);
  const [customerProfileLoading, setCustomerProfileLoading] = useState(false);
  const [editCustomerDetailsLoading, setEditCustomerDetailsLoading] =
    useState(false);
  const [updateFavouriteAddressLoading, setUpdateFavouriteAddressLoading] =
    useState(false);
  const [getFavouriteAddressLoading, setGetFavouriteAddressLoading] =
    useState(false);
  const [placesAutoCompletionLoading, setPlacesAutoCompletionLoading] =
    useState(false);
  const [getLatLongByPlaceIdLoading, setGetLatLongByPlaceIdLoading] =
    useState(false);
  const [computeDistanceRouteLoading, setComputeDistanceRouteLoading] =
    useState(false);
  const [getAllVehicleDetailsLoading, setGetAllVehicleDetailsLoading] =
    useState(false);
  const [getAllCityDetailsLoading, setGetAllCityDetailsLoading] =
    useState(false);
  const [getFaresLoading, setGetFaresLoading] =
     useState(false);
  const [bookParcelLoading, setBookParcelLoading] =
      useState(false);
  const [getPackerSlotDetailsLoading, setGetPackerSlotDetailsLoading] = 
      useState(false);
  const [addTipToFareLoading, setAddTipToFareLoading] =
  useState(false);

  const addCustomerDetailsApi = async ({
    userCode,
    firstName,
    lastName,
    privacyPolicy,
  }) => {
    try {
      setCustomerDetailsLoading(true);

      const payload = {
        userCode: userCode || "",
        firstName: firstName || "",
        lastName: lastName || "",
        privacyPolicy: privacyPolicy || "",
      };

      const response = await api.post(
        "/api/Client/v1.0/addCustomerDetails",
        payload,
      );

      return response.data;
    } catch (error) {
      console.error("Add Customer Details Error:", error);

      toast.error(
        error?.response?.data?.responseMessage || "Something went wrong",
      );

      return null;
    } finally {
      setCustomerDetailsLoading(false);
    }
  };

  const getCustomerProfileDetailsApi = async ({ userId }) => {
    try {
      setCustomerProfileLoading(true);

      const payload = {
        userId: userId || "",
      };

      const response = await api.post(
        "/api/Client/v1.0/GetCustomerProfileDetails",
        payload,
      );

      return response.data;
    } catch (error) {
      console.error("Get Customer Profile Details Error:", error);

      toast.error(
        error?.response?.data?.responseMessage || "Something went wrong",
      );

      return null;
    } finally {
      setCustomerProfileLoading(false);
    }
  };

  const editCustomerDetailsApi = async ({
    userId,
    firstName,
    lastName,
    email,
    dateOfBirth,
  }) => {
    try {
      setEditCustomerDetailsLoading(true);

      const payload = {
        userId: userId || "",
        firstName: firstName || "",
        lastName: lastName || "",
        email: email || "",
        dateOfBirth: dateOfBirth || "",
      };

      const response = await api.post(
        "/api/Client/v1.0/EditCustomerDetails",
        payload,
      );

      return response.data;
    } catch (error) {
      console.error("Edit Customer Details Error:", error);

      toast.error(
        error?.response?.data?.responseMessage || "Something went wrong",
      );

      return null;
    } finally {
      setEditCustomerDetailsLoading(false);
    }
  };

  const updateFavouriteAddressApi = async ({
    userId,
    latitude,
    longitude,
    address,
    favourite,
  }) => {
    try {
      setUpdateFavouriteAddressLoading(true);

      const payload = {
        userId: userId || "",
        latitude: latitude || "",
        longitude: longitude || "",
        address: address || "",
        favourite: favourite || "",
      };

      const response = await api.post(
        "/api/Client/v1.0/UpdateFavouriteAddress",
        payload,
      );

      return response.data;
    } catch (error) {
      console.error("Update Favourite Address Error:", error);

      toast.error(
        error?.response?.data?.responseMessage || "Something went wrong",
      );

      return null;
    } finally {
      setUpdateFavouriteAddressLoading(false);
    }
  };

  const getFavouriteAddressApi = async ({ userId }) => {
    try {
      setGetFavouriteAddressLoading(true);

      const payload = {
        userId: userId || "",
      };

      const response = await api.post(
        "/api/Client/v1.0/GetFavouriteAddress",
        payload,
      );

      return response.data;
    } catch (error) {
      console.error("Get Favourite Address Error:", error);

      toast.error(
        error?.response?.data?.responseMessage || "Something went wrong",
      );

      return null;
    } finally {
      setGetFavouriteAddressLoading(false);
    }
  };

  const placesAutoCompletionApi = async ({
    input,
    latitude,
    longitude,
    radius,
  }) => {
    try {
      setPlacesAutoCompletionLoading(true);

      const payload = {
        input: input || "",
        latitude: Number(latitude || 0),
        longitude: Number(longitude || 0),
        radius: Number(radius || 0),
      };

      const response = await api.post(
        "/api/Google/v1.0/placesAutoCompletion",
        payload,
      );

      return response.data;
    } catch (error) {
      console.error("Places Auto Completion Error:", error);

      toast.error(
        error?.response?.data?.responseMessage || "Something went wrong",
      );

      return null;
    } finally {
      setPlacesAutoCompletionLoading(false);
    }
  };

  const getLatLongByPlaceIdApi = async ({ placeId }) => {
    try {
      setGetLatLongByPlaceIdLoading(true);

      const payload = {
        placeId: placeId || "",
      };

      const response = await api.post(
        "/api/Google/v1.0/getLatLongByPlaceId",
        payload,
      );

      return response.data;
    } catch (error) {
      console.error("Get Lat Long By Place Id Error:", error);

      toast.error(
        error?.response?.data?.responseMessage || "Something went wrong",
      );

      return null;
    } finally {
      setGetLatLongByPlaceIdLoading(false);
    }
  };

  const computeDistanceRouteApi = async ({
    originLatitude,
    originLongitude,
    destinationLatitude,
    destinationLongitude,
    customerId,
  }) => {
    try {
      setComputeDistanceRouteLoading(true);

      const payload = {
        originLatitude: String(originLatitude || ""),
        originLongitude: String(originLongitude || ""),
        destinationLatitude: String(destinationLatitude || ""),
        destinationLongitude: String(destinationLongitude || ""),
        customerId: customerId || "",
      };

      const response = await api.post(
        "/api/Google/v1.0/computeDistanceRoute",
        payload,
      );

      return response.data;
    } catch (error) {
      console.error("Compute Distance Route Error:", error);

      toast.error(
        error?.response?.data?.responseMessage || "Something went wrong",
      );

      return null;
    } finally {
      setComputeDistanceRouteLoading(false);
    }
  };

  const getAllCityDetailsApi = async ({ userId }) => {
    try {
      setGetAllCityDetailsLoading(true);

      const payload = {
        userId: userId || "",
      };

      const response = await api.post(
        "/api/Client/v2.0/getAllCityDetails",
        payload,
      );

      return response.data;
    } catch (error) {
      console.error("Get All City Details Error:", error);

      toast.error(
        error?.response?.data?.responseMessage || "Something went wrong",
      );

      return null;
    } finally {
      setGetAllCityDetailsLoading(false);
    }
  };

  const getAllVehicleDetailsApi = async ({ userId }) => {
    try {
      setGetAllVehicleDetailsLoading(true);

      const payload = {
        userId: userId || "",
      };

      const response = await api.post(
        "/api/Client/v2.0/getAllVehicleDetails",
        payload,
      );

      return response.data;
    } catch (error) {
      console.error("Get All Vehicle Details Error:", error);

      toast.error(
        error?.response?.data?.responseMessage || "Something went wrong",
      );

      return null;
    } finally {
      setGetAllVehicleDetailsLoading(false);
    }
  };

  const getFaresApi = async ({ customerId }) => {
  try {
    setGetFaresLoading(true);

    const payload = {
      customerId: customerId || "",
    };

    const response = await api.post("/api/Client/v1.0/getFares", payload);

    return response.data;
  } catch (error) {
    console.error("Get Fares Error:", error);

    toast.error(
      error?.response?.data?.responseMessage || "Something went wrong",
    );

    return null;
  } finally {
    setGetFaresLoading(false);
  }
};

const bookParcelApi = async ({
  vehilceId,
  fare,
  pickUpTime,
  customerId,
  fareId,
  receiverName,
  receiverNumber,
  senderName,
  senderNumber,
}) => {
  try {
    setBookParcelLoading(true);

    const payload = {
      vehilceId: vehilceId || "",
      fare: fare || "",
      pickUpTime: pickUpTime || null,
      customerId: customerId || "",
      fareId: fareId || "",
      receiverName: receiverName || "",
      receiverNumber: receiverNumber || "",
      senderName: senderName || "",
      senderNumber: senderNumber || "",
    };

    const response = await api.post(
      "/api/Client/v1.0/bookParcel",
      payload
    );

    return response.data;
  } catch (error) {
    console.error("Book Parcel Error:", error);

    toast.error(
      error?.response?.data?.responseMessage || "Something went wrong"
    );

    return null;
  } finally {
    setBookParcelLoading(false);
  }
};

const getPackerSlotDetailsApi = async ({
  userId,
}) => {
  try {
    setGetPackerSlotDetailsLoading(
      true
    );

    const payload = {
      userId: userId || "",
    };

    const response = await api.post(
      "/api/ClientAdmin/v1.0/getPackerSlotDetails",
      payload
    );

    return response.data;
  } catch (error) {
    console.error(
      "Get Packer Slot Details Error:",
      error
    );

    toast.error(
      error?.response?.data
        ?.responseMessage ||
        "Something went wrong"
    );

    return null;
  } finally {
    setGetPackerSlotDetailsLoading(
      false
    );
  }
};

const addTipToFareApi = async ({
  parcelId,
  tipAmount,
}) => {
  try {
    setAddTipToFareLoading(true);

    const payload = {
      parcelId: parcelId || "",
      tipAmount: tipAmount || "",
    };

    const response = await api.post(
      "/api/Client/v1.0/addTipToFare",
      payload
    );

    return response.data;
  } catch (error) {
    console.error("Add Tip To Fare Error:", error);

    toast.error(
      error?.response?.data?.responseMessage ||
        "Something went wrong"
    );

    return null;
  } finally {
    setAddTipToFareLoading(false);
  }
};

  return {
    customerDetailsLoading,
    customerProfileLoading,
    editCustomerDetailsLoading,
    updateFavouriteAddressLoading,
    getFavouriteAddressLoading,
    placesAutoCompletionLoading,
    getLatLongByPlaceIdLoading,
    computeDistanceRouteLoading,
    getAllCityDetailsLoading,
    getAllVehicleDetailsLoading,
    getFaresLoading,
    bookParcelLoading,
    getPackerSlotDetailsLoading,
    addTipToFareLoading,

    addCustomerDetailsApi,
    getCustomerProfileDetailsApi,
    editCustomerDetailsApi,
    updateFavouriteAddressApi,
    getFavouriteAddressApi,
    placesAutoCompletionApi,
    getLatLongByPlaceIdApi,
    computeDistanceRouteApi,
    getAllCityDetailsApi,
    getAllVehicleDetailsApi,
    getFaresApi,
    bookParcelApi,
    getPackerSlotDetailsApi,
    addTipToFareApi,
  };
};

export default useCustomerDetails;